import { brandFeatures } from '@/mocks/homeData';

export default function BrandFeatures() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            为什么选择惠美梨
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            从枝头到舌尖，全程品质守护
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            惠美梨以六大核心优势，为您打造安心、便捷的品质梨果消费体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {brandFeatures.map((feature, index) => (
            <div
              key={index}
              className="group p-6 md:p-8 rounded-2xl bg-background-100 hover:bg-background-100 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feature.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-14 p-8 md:p-10 rounded-2xl bg-accent-100/50 text-center">
          <div className="max-w-2xl mx-auto">
            <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full bg-accent-500/20">
              <i className="ri-shield-star-line text-2xl text-accent-700"></i>
            </div>
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
              惠美梨品质承诺
            </h3>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
              每一颗惠美梨都经过<strong>严格筛选</strong>，果形、色泽、甜度、重量四项达标方可出库。我们承诺<strong>不满意无条件退换</strong>，让您购物零风险、零担忧。品质，是惠美梨的立身之本，更是我们对每一位消费者的郑重承诺。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}